import * as jsonld from "jsonld";
export async function parseRdfQuadsWithJsonLd(content) {
    const contentAsJson = JSON.parse(content);
    const options = {
        documentLoader: async (url) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const loader = jsonld.documentLoaders.node();
            // Encode the URL to allow for national characters.
            return await loader(encodeURI(url));
        },
    };
    // The dataset model match with the RdfQuad array.
    return (await jsonld.toRDF(contentAsJson, options));
}
//# sourceMappingURL=jsonld-adapter.js.map